// Constants used across the Clients module

// Mapping Province italiane (nome completo -> sigla)
export const PROVINCE_MAPPING = {
  'Metropolitan City of Florence': 'FI', 'Città Metropolitana di Firenze': 'FI', 'Florence': 'FI', 'Firenze': 'FI',
  'Metropolitan City of Milan': 'MI', 'Città Metropolitana di Milano': 'MI', 'Milan': 'MI', 'Milano': 'MI',
  'Metropolitan City of Rome': 'RM', 'Città Metropolitana di Roma': 'RM', 'Rome': 'RM', 'Roma': 'RM',
  'Metropolitan City of Naples': 'NA', 'Città Metropolitana di Napoli': 'NA', 'Naples': 'NA', 'Napoli': 'NA',
  'Metropolitan City of Turin': 'TO', 'Città Metropolitana di Torino': 'TO', 'Turin': 'TO', 'Torino': 'TO',
  'Metropolitan City of Genoa': 'GE', 'Città Metropolitana di Genova': 'GE', 'Genoa': 'GE', 'Genova': 'GE',
  'Metropolitan City of Bologna': 'BO', 'Città Metropolitana di Bologna': 'BO', 'Bologna': 'BO',
  'Metropolitan City of Venice': 'VE', 'Città Metropolitana di Venezia': 'VE', 'Venice': 'VE', 'Venezia': 'VE',
  'Metropolitan City of Bari': 'BA', 'Città Metropolitana di Bari': 'BA', 'Bari': 'BA',
  'Metropolitan City of Palermo': 'PA', 'Città Metropolitana di Palermo': 'PA', 'Palermo': 'PA',
  'Metropolitan City of Catania': 'CT', 'Città Metropolitana di Catania': 'CT', 'Catania': 'CT',
  'Metropolitan City of Cagliari': 'CA', 'Città Metropolitana di Cagliari': 'CA', 'Cagliari': 'CA',
  'Metropolitan City of Messina': 'ME', 'Città Metropolitana di Messina': 'ME', 'Messina': 'ME',
  'Metropolitan City of Reggio Calabria': 'RC', 'Città Metropolitana di Reggio Calabria': 'RC', 'Reggio Calabria': 'RC',
  'Province of Prato': 'PO', 'Provincia di Prato': 'PO', 'Prato': 'PO',
  'Province of Pistoia': 'PT', 'Provincia di Pistoia': 'PT', 'Pistoia': 'PT',
  'Province of Lucca': 'LU', 'Provincia di Lucca': 'LU', 'Lucca': 'LU',
  'Province of Pisa': 'PI', 'Provincia di Pisa': 'PI', 'Pisa': 'PI',
  'Province of Livorno': 'LI', 'Provincia di Livorno': 'LI', 'Livorno': 'LI',
  'Province of Siena': 'SI', 'Provincia di Siena': 'SI', 'Siena': 'SI',
  'Province of Arezzo': 'AR', 'Provincia di Arezzo': 'AR', 'Arezzo': 'AR',
  'Province of Grosseto': 'GR', 'Provincia di Grosseto': 'GR', 'Grosseto': 'GR',
  'Province of Massa-Carrara': 'MS', 'Provincia di Massa-Carrara': 'MS', 'Massa-Carrara': 'MS',
  'Province of Bergamo': 'BG', 'Provincia di Bergamo': 'BG', 'Bergamo': 'BG',
  'Province of Brescia': 'BS', 'Provincia di Brescia': 'BS', 'Brescia': 'BS',
  'Province of Como': 'CO', 'Provincia di Como': 'CO', 'Como': 'CO',
  'Province of Varese': 'VA', 'Provincia di Varese': 'VA', 'Varese': 'VA',
  'Province of Monza and Brianza': 'MB', 'Provincia di Monza e Brianza': 'MB', 'Monza e Brianza': 'MB',
  'Province of Padua': 'PD', 'Provincia di Padova': 'PD', 'Padova': 'PD', 'Padua': 'PD',
  'Province of Verona': 'VR', 'Provincia di Verona': 'VR', 'Verona': 'VR',
  'Province of Vicenza': 'VI', 'Provincia di Vicenza': 'VI', 'Vicenza': 'VI',
  'Province of Treviso': 'TV', 'Provincia di Treviso': 'TV', 'Treviso': 'TV',
  'Province of Perugia': 'PG', 'Provincia di Perugia': 'PG', 'Perugia': 'PG',
  'Province of Terni': 'TR', 'Provincia di Terni': 'TR', 'Terni': 'TR'
};

// Province italiane (sigle)
export const PROVINCE = [
  "AG", "AL", "AN", "AO", "AP", "AQ", "AR", "AT", "AV", "BA", "BG", "BI", "BL", "BN", "BO", "BR", "BS", "BT", "BZ",
  "CA", "CB", "CE", "CH", "CL", "CN", "CO", "CR", "CS", "CT", "CZ", "EN", "FC", "FE", "FG", "FI", "FM", "FR",
  "GE", "GO", "GR", "IM", "IS", "KR", "LC", "LE", "LI", "LO", "LT", "LU", "MB", "MC", "ME", "MI", "MN", "MO", "MS", "MT",
  "NA", "NO", "NU", "OR", "PA", "PC", "PD", "PE", "PG", "PI", "PN", "PO", "PR", "PT", "PU", "PV", "PZ",
  "RA", "RC", "RE", "RG", "RI", "RM", "RN", "RO", "SA", "SI", "SO", "SP", "SR", "SS", "SV",
  "TA", "TE", "TN", "TO", "TP", "TR", "TS", "TV", "UD", "VA", "VB", "VC", "VE", "VI", "VR", "VT", "VV"
];

// Nazioni estere più comuni
export const NAZIONI = [
  "Albania", "Algeria", "Argentina", "Australia", "Austria", "Bangladesh", "Belgio", "Bolivia", "Bosnia Erzegovina", "Brasile",
  "Bulgaria", "Camerun", "Canada", "Cile", "Cina", "Colombia", "Corea del Sud", "Costa d'Avorio", "Croazia", "Cuba",
  "Danimarca", "Ecuador", "Egitto", "El Salvador", "Emirati Arabi Uniti", "Estonia", "Etiopia", "Filippine", "Finlandia", "Francia",
  "Germania", "Ghana", "Giappone", "Grecia", "Guatemala", "Honduras", "India", "Indonesia", "Iran", "Iraq",
  "Irlanda", "Israele", "Kenya", "Kosovo", "Lettonia", "Libano", "Libia", "Lituania", "Lussemburgo",
  "Macedonia del Nord", "Marocco", "Messico", "Moldavia", "Monaco", "Montenegro", "Nigeria", "Norvegia", "Nuova Zelanda", "Paesi Bassi",
  "Pakistan", "Paraguay", "Perù", "Polonia", "Portogallo", "Regno Unito", "Repubblica Ceca", "Repubblica Dominicana", "Romania",
  "Russia", "San Marino", "Senegal", "Serbia", "Siria", "Slovacchia", "Slovenia", "Spagna", "Sri Lanka", "Stati Uniti",
  "Sudafrica", "Svezia", "Svizzera", "Thailandia", "Tunisia", "Turchia", "Ucraina", "Ungheria", "Uruguay", "Venezuela", "Vietnam"
];

// Campi anagrafici "di contatto" che vale la pena richiedere quando un documento caricato
// abbina un cliente già esistente (per CF) ma la sua scheda è incompleta — usato da
// Dimissioni.js/Ospitalita.js/CanoneRai.js per avvisare l'operatore e offrire di completarla
// subito, senza dover andare in Anagrafica Clienti a parte.
export const CLIENT_CONTACT_FIELD_LABELS = {
  address: 'Indirizzo',
  address_number: 'Numero civico',
  city: 'Città',
  postal_code: 'CAP',
  phone: 'Cellulare',
  email: 'Email',
};

export const getMissingClientContactFields = (client) => {
  if (!client) return [];
  return Object.keys(CLIENT_CONTACT_FIELD_LABELS).filter((k) => !(client[k] || '').toString().trim());
};

export const emptyClient = {
  last_name: '',
  first_name: '',
  gender: '',
  birth_date: '',
  birth_abroad: true,  // Default: Nato all'estero ATTIVO
  birth_comune: '',
  birth_provincia: '',
  birth_country: 'Cina',  // Default: Cina pre-compilato
  email: '',
  phone: '',
  whatsapp_contact: '',
  wechat_contact: '',
  fiscal_code: '',
  address: '',
  address_number: '',
  city: '',
  city_provincia: '',
  postal_code: '',
  is_company: false,
  company_name: '',
  vat_number: '',
  pec: '',
  // Company address fields (sede legale)
  company_address: '',
  company_address_number: '',
  company_city: '',
  company_provincia: '',
  company_postal_code: '',
  company_latitude: null,
  company_longitude: null,
  agent_source: 'JV SERVICE', // Default pre-compilato
  notes: '',
  tags: []
};
